import React, {useState, useEffect} from 'react';
import {ContentHeader} from '@components';
import {Form} from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import QRCode from 'qrcode.react';
import {Button} from 'react-bootstrap';
export default function Qr() {
  const [code, setCode] = useState('');
  const downloadQR = () => {
    const canvas = document.getElementById('123456');
    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');
    let downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = 'qr.png';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <div>
      <ContentHeader title="QR Generator" />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-md-6">
              <Card>
                <Card.Header>Enter Code</Card.Header>
                <Card.Body>
                  <Form.Group className="mb-3 col-md-12">
                    <Form.Control
                      as="textarea"
                      // value={costCenter}
                      value={code}
                      placeholder={'Input code'}
                      onChange={(e) => {
                        setCode(e.target.value);
                      }}
                    />
                  </Form.Group>
                </Card.Body>
              </Card>
            </div>
            <div className="col-12 col-md-6">
              {' '}
              <Card>
                <Card.Header>QR CODE</Card.Header>
                <Card.Body>
                  <div>
                    {code !== '' ? (
                      <QRCode
                        id="123456"
                        value={`https://doubleaqr.doubleapaper.com/index_gl.aspx?qr=${code}`}
                        size={290}
                        level={'H'}
                        includeMargin={true}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                  <Button
                    variant="success"
                    onClick={downloadQR}
                    disabled={code === ''}
                  >
                    Download QR
                  </Button>
                  {/* <a onClick={downloadQR}> Download QR </a> */}
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
